var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{ref:"trigger",staticClass:"ca-deferred-tip-trigger",on:{"mouseenter":_vm.open,"mouseleave":_vm.close,"focus":_vm.open,"blur":_vm.close}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }